import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useViews } from '@/hooks/use-views'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Typography } from '@/components/ui/typography'
import logoCompassImg from '@/assets/images/greybull-logo.svg'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Route = createFileRoute('/_authenticated/companies/' as any)({
  component: CompaniesIndex,
})

/**
 * Index route redirects to the default view
 */
function CompaniesIndex() {
  const { views, isLoading, isError, refetch } = useViews('COMPANY')

  // Show loading while fetching views
  if (isLoading) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <img
          src={logoCompassImg}
          alt="Loading"
          className="w-auto h-16 animate-pulse"
        />
      </div>
    )
  }

  // Show error state if views failed to load
  if (isError) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <Card className="w-[370px] border border-primary/50 rounded-md p-8">
          <CardContent className="flex flex-col items-center p-0 text-center">
            <Typography variant="h4" className="font-bold">
              Failed to load views
            </Typography>
            <Typography
              variant="p"
              className="mt-2 text-base font-normal text-primary"
            >
              Something went wrong. Please try again.
            </Typography>
            <Button
              variant="outline"
              onClick={() => refetch()}
              className="mt-4"
            >
              Try Again
            </Button>
          </CardContent>
        </Card>
      </div>
    )
  }

  // Find default view or use first view
  const defaultView = views.find((v) => v.isDefault) || views[0]

  // Redirect to default view if available
  if (defaultView) {
    return (
      <Navigate
        to="/companies/views/$viewId"
        params={{ viewId: defaultView.id }}
        replace
      />
    )
  }

  // No views available - show empty state
  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center gap-4">
      <Typography variant="muted">No views available</Typography>
    </div>
  )
}
